import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService, BalanceService } from 'core';
import { ReferralClipboardService } from 'core/services/referral-clipboard.service';
import { KorviuButtonComponent, ThousandsSeparatorPipe } from 'shared';
import { Router } from '@angular/router';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { ReferralModalFacade } from '../../../shared/services/referral-modal.facade';
import { getUserLevelFromLeaves } from 'shared/utils';
import { HideTooltipOnScrollDirective } from 'shared/directives';
import { RefreshOnLanguageChangeDirective } from 'shared/directives/refresh-on-language-change.directive';

@Component({
  selector: 'app-top-widget',
  imports: [
    TranslatePipe,
    KorviuButtonComponent,
    ThousandsSeparatorPipe,
    NzTooltipDirective,
    HideTooltipOnScrollDirective
  ],
  templateUrl: './top-widget.component.html',
  styleUrl: './top-widget.component.scss',
  hostDirectives: [RefreshOnLanguageChangeDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TopWidgetComponent {
  private readonly referralClipboard = inject(ReferralClipboardService);

  authService = inject(AuthService);
  balanceService = inject(BalanceService);
  router = inject(Router);
  referralModalFacade = inject(ReferralModalFacade);

  currentUser = this.authService.currentUser$;

  get currentUserIsSpecial(): boolean {
    return this.currentUser()?.isSpecial ?? false;
  }

  get currentCommission(): number {
    return this.currentUser()?.currentCommission || 0;
  }

  get totalLeaves(): number {
    return this.currentUser()?.leaves ?? 0;
  }

  get growingGanas(): number {
    return this.currentUser()?.balance?.potential || 0;
  }

  get availableGanas(): number {
    return this.balanceService.balanceGanas();
  }

  get spending(): number {
    return this.currentUser()?.spentMoney || 0;
  }

  get referralNumber(): string {
    return this.currentUser()?.referralCode || '';
  }

  get userLevel(): number {
    return getUserLevelFromLeaves(this.currentUser()?.leaves);
  }

  get levelImageUrl(): string {
    return `assets/img/dashboard-v2/${this.userLevel}level.webp`;
  }

  get levelMobileImageUrl(): string {
    return `assets/img/dashboard-v2/${this.userLevel}level-mobile.svg`;
  }

  get promoFundBalance(): number {
    return this.currentUser()?.partnerPromoFundBalance || 0;
  }

  copyReferralCode(): void {
    void this.referralClipboard.copy(this.currentUser()?.referralCode);
  }

  goToMyForest(): void {
    this.router.navigate(['workspace/my-forest']);
  }

  goToPromotions(): void {
    this.router.navigate(['workspace/promotions']);
  }

  plantASeed(): void {
    this.referralModalFacade.openAddReferralModal();
  }
}
